export default __webpack_public_path__ + "static/media/Grips of the Ubah Kan.c285ba9f.jpg";